// Styles
import "../styles/UserAuthPage.css";
// Components
import LeftPanel from "../components/auth/userAuthComponents/LeftPanel";
import UserForm from "../components/auth/userAuthComponents/UserForm";

function UserAuthPage() {
  return (
    <section className="authPage">
      <div className="authPage__card">
        {/* LEFT PANEL — image and stats */}
        <LeftPanel />

        {/* RIGHT PANEL — the form */}
        <UserForm />
      </div>
    </section>
  );
}

export default UserAuthPage;
